module.exports = __webpack_public_path__ + "static/media/userPhoto.3a14deff.jpg";